import { RadarSummaryArrowStyle } from '../../../settings/settings';
import { StyleFactory, WeatherLayerSpecification } from '../styling';

// TODO: remove light variable from the parameters and use global state
export const radarSummaryLayers: StyleFactory = (baseId, settings) => {
    const layers: WeatherLayerSpecification[] = [];
    const speedBased = settings.radar.radarSummarySpeedArrowStyle === RadarSummaryArrowStyle.speedBased;

    if (speedBased) {
        layers.push(
            {
                id: baseId + '-circles',
                type: 'circle',
                filter: ['all', ['==', ['get', 'type'], 's'], ['>', ['zoom'], ['get', 'zoom']]],
                source: baseId,
                paint: {
                    'circle-color': ['global-state', 'text-color'],
                    'circle-radius': ['interpolate', ['linear'], ['zoom'], 0, 2, 4, 3, 6, 4]
                }
            },
            {
                id: baseId + '-lines',
                type: 'line',
                source: baseId,
                filter: ['>', ['zoom'], ['get', 'zoom']],
                paint: {
                    'line-color': ['global-state', 'text-color'],
                    'line-width': ['interpolate', ['linear'], ['zoom'], 0, 1, 4, 2]
                }
            },
            {
                id: baseId + '-arrows',
                filter: ['all', ['==', ['get', 'type'], 'e'], ['>', ['zoom'], ['get', 'zoom']]],
                type: 'symbol',
                source: baseId,
                layout: {
                    'icon-image': ['image', 'fe-weather:arrow'],
                    'icon-rotate': ['get', 'dir'],
                    'icon-rotation-alignment': 'map',
                    'icon-size': ['interpolate', ['linear'], ['zoom'], 0, 0.1, 4, 0.25, 6, 0.6],
                    'icon-allow-overlap': true,
                    'symbol-placement': 'point'
                },
                paint: {
                    'icon-color': ['global-state', 'text-color']
                }
            },
            {
                minzoom: 4,
                id: baseId + '-midpoints',
                type: 'symbol',
                filter: ['all', ['==', ['get', 'type'], 'm'], ['>', ['zoom'], ['get', 'zoom']]],
                source: baseId,
                layout: {
                    'icon-image': ['image', 'fe-weather:line'],
                    'icon-allow-overlap': true,
                    'icon-anchor': 'center',
                    'icon-rotate': ['get', 'dir'],
                    'icon-rotation-alignment': 'map',
                    'icon-size': ['interpolate', ['linear'], ['zoom'], 0, 0, 8, 0.7]
                },
                paint: {
                    'icon-color': ['global-state', 'text-color']
                }
            }
        );
    } else {
        layers.push({
            id: baseId + '-arrows',
            source: baseId,
            filter: ['all', ['==', ['get', 'type'], 's'], ['>', ['zoom'], ['get', 'zoom']]],
            type: 'symbol',
            layout: {
                'icon-image': ['image', 'fe-weather:radar-summary-arrow'],
                'icon-rotate': ['get', 'dir'],
                'icon-anchor': 'bottom',
                'icon-offset': [0, 7],
                'icon-allow-overlap': true,
                'icon-rotation-alignment': 'map',
                'icon-size': 1
            },
            paint: {
                'icon-color': ['global-state', 'text-color']
            }
        });
    }

    layers.push(
        {
            id: baseId + '-label',
            minzoom: 4,
            filter: ['all', ['==', ['get', 'type'], 's'], ['>', ['zoom'], ['get', 'zoom']]],
            source: baseId,
            type: 'symbol',
            layout: {
                'text-field': [
                    'format',
                    ['get', 'tvs'],
                    { 'text-color': '#fa075b' },
                    ['get', 'meso'],
                    { 'text-color': '#fa7d00' },
                    ['get', 'hail'],
                    { 'text-color': '#fdff03' }
                ],
                'text-offset': [0, 0.5],
                'text-allow-overlap': true,
                'text-anchor': 'top',
                'text-font': ['Metropolis Bold'],
                'text-size': 11
            },
            paint: {
                'text-halo-color': 'rgb(0,0,0,0.5)',
                'text-halo-width': 1
            }
        },
        {
            id: baseId + '-label-tops',
            minzoom: 4,
            filter: ['all', ['==', ['get', 'type'], 's'], ['>', ['zoom'], ['get', 'zoom']]],
            source: baseId,
            type: 'symbol',
            layout: {
                'text-field': ['get', 'tops'],
                'text-offset': ['get', 'topsOffset'],
                'text-allow-overlap': true,
                'text-anchor': 'top',
                'text-font': ['Metropolis Bold'],
                'text-size': 11
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    );

    if (settings.radar.radarSummaryShowSpeedLabel) {
        if (speedBased) {
            layers.push({
                id: baseId + '-speed',
                minzoom: 4,
                filter: ['all', ['==', ['get', 'type'], 'e'], ['>', ['zoom'], ['get', 'zoom']]],
                source: baseId,
                type: 'symbol',
                layout: {
                    'text-field': ['get', 'speed'],
                    'text-offset': [0, -0.5],
                    'text-allow-overlap': true,
                    'text-anchor': 'bottom',
                    'text-font': ['Open Sans Regular'],
                    'text-size': 10
                },
                paint: {
                    'text-color': ['global-state', 'text-color']
                }
            });
        } else {
            layers.push({
                id: baseId + '-speed',
                minzoom: 4,
                filter: ['all', ['==', ['get', 'type'], 's'], ['>', ['zoom'], ['get', 'zoom']]],
                source: baseId,
                type: 'symbol',
                layout: {
                    'text-field': ['get', 'speed'],
                    'text-allow-overlap': true,
                    'text-anchor': 'center',
                    'text-font': ['Open Sans Regular'],
                    'text-size': 10,
                    'text-offset': ['get', 'offset'],
                    'text-rotation-alignment': 'map'
                },
                paint: {
                    'text-color': ['global-state', 'text-color']
                }
            });
        }
    }

    return layers;
};
